'use client';

import { useTheme } from '@mui/material/styles';
import { type FC, useMemo } from 'react';

type Props = {
  gradientId?: string;
};

export const Gradient: FC<Props> = (props) => {
  const { gradientId } = props;

  const theme = useTheme();

  const gradientCompleteId = useMemo(() => {
    if (gradientId) {
      return gradientId;
    }

    return `totem-gradient`;
  }, [gradientId]);

  return (
    <svg
      width="100%"
      height="100%"
      style={gradientId ? { position: 'absolute' } : undefined}
    >
      <defs>
        <linearGradient
          id={gradientCompleteId}
          viewBox="0 0 532 532"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={theme.palette.primary.main} />
          <stop offset="1" stopColor={theme.palette.primary.light} />
        </linearGradient>
      </defs>
    </svg>
  );
};
